import React from "react";

const Speaker = props => (
  <svg aria-hidden={true} width={24} height={24} viewBox="0 0 24 24">
    <path
      d="M2 10h4c.266 0 .52-.105.707-.293L12 4.414v15.172l-5.293-5.293A.996.996 0 0 0 6 14H2v-4zm11.383 12.924A.999.999 0 0 0 14 22V2a1 1 0 0 0-1.707-.707L5.586 8H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4.586l6.707 6.707a1 1 0 0 0 1.09.217zm7.805-4.23A9.272 9.272 0 0 0 24 12.019a9.26 9.26 0 0 0-2.864-6.726.998.998 0 0 0-1.413.026.998.998 0 0 0 .026 1.413A7.288 7.288 0 0 1 22 12.018c0 1.997-.79 3.865-2.223 5.26-.027.028-.041.065-.065.096a.99.99 0 0 0 .042 1.323.999.999 0 0 0 1.414.02l.019-.021.001-.001zM20 12.019c0 1.576-.721 3.049-1.977 4.044a.999.999 0 0 1-1.242-1.568A3.15 3.15 0 0 0 18 12.018c0-.994-.465-1.914-1.274-2.525a.999.999 0 1 1 1.205-1.596A5.13 5.13 0 0 1 20 12.017z"
      fill={props.fill}
      fillRule="evenodd"
    />
  </svg>
);

export default Speaker;
